import useMedia from "use-media"

export function useConfiguratorDimensions() {
  // 1000px
  const is1200up = useMedia({ minWidth: 1200 }) // 1400px
  const is1600up = useMedia({ minWidth: 1600 }) // 1600px

  // 1000 px
  // 150 | 150 | 300 | 150 | 150
  let width = 900
  let slideWidth = 150
  let slidesBothSides = 2

  if (is1200up) {
    // 200 | 200 | 400 | 200 | 200
    slideWidth = 200
    width = 1200
    slidesBothSides = 2
  }
  if (is1600up) {
    // 200 | 200 | 200 | 400 | 200 | 200 | 200
    slideWidth = 200
    width = 1600
    slidesBothSides = 3
  }

  return { slideWidth, width, slidesBothSides }
}
